export default {
  all: [],
  one: {
  },
};
